import { ViewModel,View, ObservableArray, ViewModelMessage } from "binder"
import  { PurchaseProcessView } from "./purchaseProcess-view"
import { ServerConnection } from "src/server/serverConnection";
import moment from "moment";
import { Enum, IEnumTranslator } from "uicomponents";
import { TranslatorConverter } from "src/TranslatorConverter";
import { stringIsNullOrEmpty } from "src/common/utilities";

export class PurchaseProcessViewModel extends ViewModel{
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
        this.items = ObservableArray.create<singleProcess>();
        this.stateEnumProvider = new PurchaseProcessStateEnumProvider();
        this.refresh();
    }
    GetDefaultView(): View <ViewModel> {
        return new PurchaseProcessView();
    }
    public getTypeId(): string {
        return "VM-35BBDB2D-34C9-46F1-B7C2-1C676D445EA1"
    }

    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set items(v: ObservableArray<singleProcess>) { this._items = v; } public get items(): ObservableArray<singleProcess> { return this._items;} private _items: ObservableArray<singleProcess>;
    public set selectedProcess(v: singleProcess) { this._selectedProcess = v; } public get selectedProcess(): singleProcess { return this._selectedProcess;} private _selectedProcess: singleProcess;
    public set stateEnumProvider(v: PurchaseProcessStateEnumProvider) { this._stateEnumProvider = v; } public get stateEnumProvider(): PurchaseProcessStateEnumProvider { return this._stateEnumProvider;} private _stateEnumProvider: PurchaseProcessStateEnumProvider;
    public set containerNo(v: string) { this._containerNo = v; } public get containerNo(): string { return this._containerNo;} private _containerNo: string;
    
    async refresh(): Promise<any> {
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/ImportProductServices/ListAllPurchaseProcesses',{
            });
            this.items.update(...result.PurchaseProcesses.map((x,i)=>{
                let r= new singleProcess(this);
                r.index = i+1;
                r.id = x.Id;
                r.code = x.Code;
                r.time = moment.utc(x.Time);
                r.lastState = x.LastState;
                return r;
            }))
        } catch (ex) {
            console.log(ex);
        } finally {
            this.isLoading = false;
        }
    }
        
    async search(): Promise<any> {
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/ImportProductServices/SearchProcessByContainerNo',{
                SearchText: this.containerNo
            });
            if(result.IsSuccessful && stringIsNullOrEmpty(result.ProcessNo) == false){
                await this.messageBoxConfirmSuccess(`شماره کانتینر ${this.containerNo} در شماره بازرگانی ${result.ProcessNo} یافت شد.`,"نتیجه جستجو")
            }else{
                await this.messageBoxConfirmWarning(`شماره کانتینر ${this.containerNo} یافت نشد.`,"نتیجه جستجو")
            }
        } catch (ex) {
            console.log(ex);
        } finally {
            this.isLoading = false;
        }
    }
    
    async createNew(){
        try {
            this.isLoading = true;
            let confirmationResult = await this.messageBoxWarningYesNo('آیا بازرگانی جدید ایجاد شود؟','ایجاد بازرگانی');
            if(confirmationResult=='no')
                return;
            let result =await ServerConnection.callServer('/Complex/ImportProductServices/CreateNewPurchaseProcess',{
            });
            if(result.IsSuccessful){
                await this.messageBoxConfirmSuccess('عملیات با موفقیت انجام شد.',"عملیات موفق")
                this.isLoading = false;
                this.refresh();
            }else{
                await this.messageBoxConfirmWarning('خطا در انجام عملیات.',"عملیات نا موفق")
                this.isLoading = false;
            }

        } catch (ex) {
            console.log(ex);
            await this.messageBoxConfirmWarning('خطا در انجام عملیات.',"عملیات نا موفق")
            this.isLoading = false;
        } finally {
        }
    }

    processSelected(process:singleProcess){
        this.items.forEach(x=>x.isSelected =false);
        this.selectedProcess = process;
        if(this.selectedProcess!=null)
            this.selectedProcess.isSelected = true;
        this.onProcessSelectionChanged(this.selectedProcess);
    }
    async deleteProcess(process:singleProcess){
        try {
            let confirmationResult = await this.messageBoxDangerYesNo(`آیا بازرگانی با شماره ${process.code} حذف شود؟`,'حذف بازرگانی');
            if(confirmationResult=='no')
                return;
            this.isLoading = true;
            let result =await ServerConnection.callServer('/Complex/ImportProductServices/DeletePurchaseProcess',{
                ProcessId : process.id
            });
            if(result.IsSuccessful){
                await this.messageBoxConfirmSuccess('عملیات با موفقیت انجام شد.',"عملیات موفق")
                this.isLoading = false;
                this.refresh();
            }else{
                await this.messageBoxConfirmWarning('خطا در انجام عملیات.',"عملیات نا موفق")
                this.isLoading = false;
            }

        } catch (ex) {
            console.log(ex);
            await this.messageBoxConfirmWarning('خطا در انجام عملیات.',"عملیات نا موفق")
            this.isLoading = false;
        } finally {
        }
    }
    public onProcessSelectionChanged(newOne : singleProcess){

    }

    async compare(singleProcess:singleProcess){
        let message = new RequestPurchaseProcessCompareMessage();
        message.singleProcessId = singleProcess.id;
        message.code  = singleProcess.code;
        this.handleMessage(message);
    }
}
export class RequestPurchaseProcessCompareMessage extends ViewModelMessage{
    public singleProcessId : string;
    public code : string;
    
}


export class singleProcess extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:PurchaseProcessViewModel) {
        super(parent);
        this._typedParent = parent;
        this.isSelected = false;
    }
    
    private _typedParent : PurchaseProcessViewModel;
    public set index(v: number) { this._index = v; } public get index(): number { return this._index;} private _index: number;
    
    public set id(v: string) { this._id = v; } public get id(): string { return this._id;} private _id: string;
    public set code(v: string) { this._code = v; } public get code(): string { return this._code;} private _code: string;
    public set time(v: moment.Moment) { this._time = v; } public get time(): moment.Moment { return this._time;} private _time: moment.Moment;
    public set lastState(v: number) { this._lastState = v; } public get lastState(): number { return this._lastState;} private _lastState: number;
    public set isSelected(v: boolean) { this._isSelected = v; } public get isSelected(): boolean { return this._isSelected;} private _isSelected: boolean;
    
    select(){
        this._typedParent.processSelected(this);
    }

    delete(){
        this._typedParent.deleteProcess(this);
    }

    compare(){
        this._typedParent.compare(this);
    }
}

export class PurchaseProcessStateEnumProvider extends Enum implements IEnumTranslator{
    constructor() {
        super();

        this.translator = this;
        this.values = [1,2,4,8,16,32,64,4096];        
        
    }
    GetString(value: any) {
        return new TranslatorConverter().PurchaseProcessStateNameConverter(value);
    }
}